var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeAmenity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3917 4.4418L16.2333 4.70846C15.4083 4.90013 14.7583 5.5418 14.5667 6.37513L14.3 7.53343C14.275 7.6501 14.0917 7.6501 14.0667 7.53343L13.8 6.37513C13.6083 5.55013 12.9667 4.90013 12.1333 4.70846L10.975 4.4418C10.8583 4.4168 10.8583 4.23346 10.975 4.20846L12.1333 3.9418C12.9583 3.75013 13.6083 3.10846 13.8 2.27513L14.0667 1.1168C14.0917 1.00013 14.275 1.00013 14.3 1.1168L14.5667 2.27513C14.7583 3.10013 15.4 3.75013 16.2333 3.9418L17.3917 4.20846C17.5083 4.23346 17.5083 4.4168 17.3917 4.4418Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 1.2C9.67499 0.266667 7.98332 0.266667 6.78333 1.2L1.78333 5.09167C0.975 5.725 0.5 6.69167 0.5 7.72504V13.6834C0.5 15.525 1.99167 17.0167 3.83333 17.0167H13.8333C15.675 17.0167 17.1667 15.525 17.1667 13.6834V7.72504",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82501 11.1831V13.6831",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAmenity);
export default __webpack_public_path__ + "static/media/home-amenity.9a8406241019fc8b6afdd585d2acd5ce.svg";
export { ForwardRef as ReactComponent };